import axios from 'axios'
import { cloneDeep, isEmpty } from 'lodash'
import { message } from 'antd'

import history from '../common/history'

const { CancelToken } = axios
window.cancelRequest = new Map()


export default function request(options) {
  let { data, url, method = 'get' } = options
  const cloneData = cloneDeep(data)

  options.url = url
  if (method === "get") {
    options.params = cloneData
  } else {
    options.data = cloneData
  }
  options.cancelToken = new CancelToken(cancel => {
    window.cancelRequest.set(Symbol(Date.now()), {
      pathname: window.location.pathname,
      cancel,
    })
  })

  if (sessionStorage.getItem("token")) {
    axios.defaults.headers.common['Authorization'] = sessionStorage.getItem("token");
  }
  // if (options.isUplaod) {
  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
  // } else {
  //   axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  // }


  return axios(options)
    .then(response => {
      console.log('response', response);
      const { status } = response
      let result = {}
      if (status === 200) {
        result = response.data;
        console.log('response-result', result);
        console.log(result,'成功喽')
          return Promise.resolve(result)
      }
      else{
        console.log(result,'失败了')
        if (result.status === 400){
            message.error(`${result.data.message}`)
            return Promise.reject({
              success: false,
              data:{},
            })      
          }
      }
    })
     .catch(error => {
      const { response } = error
      if(response.data.error === "Unauthorized") {
        history.replace('/login');
        if(response.data.status !== 200) {
          return
        }
      }
      console.log(response)
      console.log('请求失败了')
      message.error(`${response.data.message}`)
      return Promise.resolve(response)
    });
}



// WEBPACK FOOTER //
// ./src/utils/request.js